<section>
<app-landing-sidenav></app-landing-sidenav>
<div class="main-content">
    <router-outlet></router-outlet>
</div>
<ng-http-loader></ng-http-loader>
</section>